export type IcpGeography = {
  countries: string[]
  regions: string[]
  cities: string[]
}

export type Icp = {
  id: string
  workspaceId: string
  name: string
  industries: string[]
  companySizes: string[]
  jobTitles: string[]
  geography: IcpGeography
  buyingSignals: string[]
  // Exactly one ICP per workspace is primary — what features that don't yet take an
  // explicit ICP (prospecting, qualification, follow-ups) use.
  isPrimary: boolean
  // Saving an ICP counts as reviewing it; the 90-day review reminder keys on this.
  reviewedAt: string
  reviewedBy: string | null
  createdBy: string | null
  createdAt: string
  updatedAt: string
}

// What the create and update calls send. geography/buyingSignals are optional: on create
// they default to empty, on update an omitted one keeps its stored value.
export type IcpInput = {
  name: string
  industries: string[]
  companySizes: string[]
  jobTitles: string[]
  geography?: IcpGeography
  buyingSignals?: string[]
}

// Mirrors the backend limits (icps/types.ts, shared/icp-schema.ts).
export const MAX_ICPS = 5
export const ICP_NAME_MAX_LENGTH = 60
export const ICP_REVIEW_DUE_DAYS = 90

// "Complete" is the bar the Company Profile has always used for target customers:
// industries, company sizes and job titles all filled in.
export function isIcpComplete(icp: Pick<Icp, 'industries' | 'companySizes' | 'jobTitles'>): boolean {
  return icp.industries.length > 0 && icp.companySizes.length > 0 && icp.jobTitles.length > 0
}

export function daysSince(iso: string, now: number = Date.now()): number {
  return Math.max(0, Math.floor((now - new Date(iso).getTime()) / (24 * 60 * 60 * 1000)))
}
